import React, { PropsWithChildren } from 'react';

import { DetailRow } from '../detail-row/DetailRow';
import { DetailRowLabel } from '../detail-row/DetailRowLabel';
import { DetailRowTooltip } from '../detail-row/DetailRowTooltip';
import { DetailRowValue } from '../detail-row/DetailRowValue';

export const TaxImpactGainsAllowanceRealizedGains: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <DetailRow>
      <DetailRowLabel>
        Net realized gains YTD
        <DetailRowTooltip data-testid="gains-allowance-ytd-realized-gains-tooltip">
          Your client's year-to-date net realized capital gains relative to their gains allowance.
        </DetailRowTooltip>
      </DetailRowLabel>
      <DetailRowValue>{children}</DetailRowValue>
    </DetailRow>
  );
};
